import { CoreContext } from 'context/CoreContext';
import { useContext, useEffect, useMemo } from 'react';
import DashboardSide from '../Side';
import InfoTicker from '../Ticker';
import {
  DashboardHeaderAction,
  DashboardHeaderActionIcon,
  DashboardHeaderContainer,
} from './styled';

// Os indicadores vem do CoreContext, e nao de um fetch local: este componente e
// remontado a cada troca de rota, entao buscar aqui significava uma chamada por
// navegacao. No contexto, a busca acontece uma vez por sessao.
export default function DashboardHeader({ opened, setOpened }) {
  const { appData, reloadAppData } = useContext(CoreContext);

  useEffect(() => {
    reloadAppData();
  }, [reloadAppData]);

  // O cabecalho e o menu sao renderizados SEMPRE, mesmo sem os indicadores.
  // Antes havia um `return <div>Carregando indicadores...</div>` aqui, e como o
  // <DashboardSide /> fica dentro deste return, ele levava a sidebar junto: a
  // cada navegacao o menu inteiro sumia e voltava. O que falta enquanto a
  // chamada nao responde e so o valor de cada item do ticker.
  const appInfo = useMemo(
    () => [
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: 'SIMULADO:', value: appData?.pre_proposal?.simulado ?? '—' },
      { label: 'PRÉ-APROVADO:', value: appData?.pre_proposal?.aprovado ?? '—' },
      { label: 'PROPOSTAS:', value: appData?.financing?.propostas ?? '—' },
      { label: 'ELEGÍVEIS:', value: appData?.financing?.elegiveis ?? '—' },
      { label: 'EM ANÁLISE:', value: appData?.financing?.em_analise ?? '—' },
      { label: 'APROVADAS:', value: appData?.financing?.aprovadas ?? '—' },
      { label: 'A PAGAR:', value: appData?.financing?.a_pagar ?? '—' },
      { label: 'TOTAL:', value: appData?.financing?.total ?? '—' },
      { label: 'PAGO NO MÊS:', value: appData?.financing?.pago_mes ?? '—' },
    ],
    [appData]
  );

  return (
    <>
      <DashboardHeaderContainer opened={opened}>
        <DashboardHeaderAction onClick={() => setOpened(!opened)}>
          <DashboardHeaderActionIcon
            src={`/icons/panel-left.svg`}
            alt="menu-icon"
          />
        </DashboardHeaderAction>
        <InfoTicker data={appInfo} />
      </DashboardHeaderContainer>
      <DashboardSide opened={opened} setOpened={setOpened} />
    </>
  );
}
